
























import {Component, Prop, Vue} from 'vue-property-decorator';
import JdsIcon from "@/design-system/icons/JdsIcon.vue"
import JdsGlyph from "@/design-system/icons/JdsGlyph.vue"

/**
 * @status stable
 * @published 4.0.0
 * @changelog 4.0.0 Published.
 */
@Component({
    components: {JdsGlyph, JdsIcon}
})
export default class JdsAttributeSticker extends Vue {
    @Prop({default: ''}) value!: string;
    @Prop({default: false, type: Boolean}) identity!: boolean;
    @Prop({default: false, type: Boolean}) allowDelete!: boolean;

    @Prop({default: 'boolean'}) type!: 'boolean'|'scale';
}
